// // ProjectCard.jsx
// import React from "react";
// const ProjectCard = ({ image, title, consultant, scope }) => {
//   return (
//     <div className="w-80 h-100 rounded overflow-hidden shadow-lg bg-white flex flex-col">
//       {/* صورة المشروع */}
//       <img
//         className="w-full h-48 object-cover"
//         src={image}
//         alt={title}
//       />
//       <div className="px-6 py-4 flex-1 flex flex-col justify-between">
//         {/* عنوان المشروع */}
//         <div className="font-bold text-xl mb-2">{title}</div>

//         {/* اسم الـ Consultant */}
//         <p className="text-gray-700 text-base mb-2">
//           <span className="font-semibold">Consultant:</span> {consultant}
//         </p>

//         {/* Scope of Work */}
//         <p className="text-gray-700 text-base">
//           <span className="font-semibold">Scope of Work:</span> {scope}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ProjectCard;

// import React from "react";

// const ProjectCard = ({ image, title, client, consultant, scope, status }) => {
//   // دالة لتحديد لون الـ status
//   const getStatusColor = (status) => {
//     if (!status) return "text-gray-700";
//     if (status.toLowerCase() === "in progress") return "text-green-600 font-semibold";
//     if (status.toLowerCase() === "completed") return "text-blue-600 font-semibold";
//     return "text-gray-700";
//   };

//   return (
//     <div className="w-80 rounded overflow-hidden shadow-lg bg-white flex flex-col">
//       {/* صورة المشروع */}
//       <img
//         className="w-full h-48 object-cover"
//         src={image}
//         alt={title}
//       />

//       <div className="px-6 py-4 flex-1 flex flex-col">
//         {/* عنوان المشروع */}
//         <div className="font-bold text-xl mb-2">{title}</div>

//         {/* اسم الـ client */}
//         <p className="text-gray-700 text-base mb-2">
//           <span className="font-semibold">Client Name:</span> {client}
//         </p>

//         {/* اسم الـ Consultant */}
//         <p className="text-gray-700 text-base mb-2">
//           <span className="font-semibold">Consultant:</span> {consultant}
//         </p>

//         {/* Scope of Work */}
//         <p className="text-gray-700 text-base mb-2">
//           <span className="font-semibold">Scope of Work:</span> {scope}
//         </p>

//         {/* Status */}
//         <p className="text-gray-700 text-base mt-2">
//           <span className="font-semibold">Status:</span>{" "}
//           <span className={getStatusColor(status)}>{status}</span>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ProjectCard;

// import React from "react";

// const ProjectCard = ({ image, title, client, consultant, scope, status }) => {
//   // دالة لتحديد لون الـ status
//   const getStatusColor = (status) => {
//     if (!status) return "text-gray-700";
//     if (status.toLowerCase() === "in progress")
//       return "text-blue-600 font-semibold";
//     if (status.toLowerCase() === "completed")
//       return "text-green-600 font-semibold";
//     return "text-gray-700";
//   };

//   return (
//     <div
//       className="rounded-2xl overflow-hidden shadow-md bg-white flex flex-col
//                  transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
//     >
//       {/* صورة المشروع مع عنوان Overlay */}
//       <div className="relative w-full h-40">
//         <img className="w-full h-full object-cover" src={image} alt={title} />
//         <div
//           className="absolute bottom-0 w-full px-4 py-2
//                 bg-black/50 backdrop-blur-sm"
//         >
//           <h3 className="text-white text-lg font-bold truncate drop-shadow-lg">
//             {title}
//           </h3>
//         </div>
//       </div>

//       <div className="px-5 py-4 flex-1 flex flex-col">
//         {/* اسم الـ client */}
//         <p className="text-gray-700 text-sm mb-1">
//           <span className="font-semibold">Client:</span> {client}
//         </p>

//         {/* اسم الـ Consultant */}
//         <p className="text-gray-700 text-sm mb-1">
//           <span className="font-semibold">Consultant:</span> {consultant}
//         </p>

//         {/* Scope of Work */}
//         <p className="text-gray-700 text-sm mb-1">
//           <span className="font-semibold">Scope:</span> {scope}
//         </p>

//         {/* Status */}
//         <p className="text-gray-700 text-sm mt-2">
//           <span className="font-semibold">Status:</span>{" "}
//           <span className={`${getStatusColor(status)} capitalize`}>
//             {status}
//           </span>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ProjectCard;

import React, { useState } from "react";

const ProjectCard = ({
  image,
  title,
  client,
  consultant,
  scope,
  status,
  details,
}) => {
  const [open, setOpen] = useState(false);

  const getStatusColor = (status) => {
    if (!status) return "text-gray-700";
    if (status.toLowerCase() === "in progress")
      return "text-blue-600 font-semibold";
    if (status.toLowerCase() === "completed")
      return "text-green-600 font-semibold";
    return "text-gray-700";
  };

  return (
    <>
      {/* الكارت */}
      <div
        onClick={() => setOpen(true)}
        className="rounded-2xl overflow-hidden shadow-md bg-white flex flex-col
                   transform transition-all duration-300 hover:scale-105 hover:shadow-2xl
                   cursor-pointer"
      >
        {/* الصورة في الكارت */}
        <div className="relative w-full h-48 overflow-hidden">
          <img src={image} alt={title} className="w-full h-full object-cover" />
          <div className="absolute bottom-0 w-full px-4 py-2 bg-black/50 backdrop-blur-sm">
            <h3 className="text-white text-lg font-bold truncate drop-shadow-lg">
              {title}
            </h3>
          </div>
        </div>

        <div className="px-5 py-4 flex-1 flex flex-col">
          <p className="text-gray-700 text-sm mb-1">
            <span className="font-semibold">Client:</span> {client}
          </p>
          <p className="text-gray-700 text-sm mb-1">
            <span className="font-semibold">Consultant:</span> {consultant}
          </p>
          <p className="text-gray-700 text-sm mb-1">
            <span className="font-semibold">Scope:</span> {scope}
          </p>
          <p className="text-gray-700 text-sm mt-2">
            <span className="font-semibold">Status:</span>{" "}
            <span className={`${getStatusColor(status)} capitalize`}>
              {status}
            </span>
          </p>
        </div>
      </div>

      {/* المودال */}
      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setOpen(false)} // يقفل لما تضغطي برة
        >
          <div
            className="bg-white rounded-2xl shadow-lg max-w-2xl w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()} // يمنع الغلق لما تضغطي جوه
          >
            {/* صورة المشروع */}
            <img src={image} alt={title} className="w-full h-64 object-cover" />

            {/* بيانات المشروع */}
            <div className="p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">{title}</h2>
              <div className="space-y-2 text-gray-700 text-sm">
                <p>
                  <span className="font-semibold">Client:</span> {client}
                </p>
                <p>
                  <span className="font-semibold">Consultant:</span>{" "}
                  {consultant}
                </p>
                <p>
                  <span className="font-semibold">Scope:</span> {scope}
                </p>
                <p>
                  <span className="font-semibold">Status:</span>{" "}
                  <span className={`${getStatusColor(status)} capitalize`}>
                    {status}
                  </span>
                </p>
                {details && details.trim() !== "" && (
                  <p className="mt-3 leading-relaxed">
                    <span className="font-semibold">Details:</span> {details}
                  </p>
                )}
              </div>

              {/* زرار الغلق */}
              <div className="mt-6 text-right">
                <button
                  onClick={() => setOpen(false)}
                  className="px-5 py-2 bg-transparent text-[#201C59] font-semibold hover:underline transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectCard;
